import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { CabinQuickSearch, SectionHeader } from '../../common/components';

const DefaultRates = () => {
  return (
    <>
      <Helmet>
        <title>Hinnoittelu - Oletushintakaudet</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          Breadcrumbs={['Hinnoittelu']}
          Title="Oletushintakaudet"
        />
        <div className="my-48">
          <CabinQuickSearch
            NavigateUrl="/rates/defaultrate"
            Subtitle="Hae kohde jonka hinnoittelua haluat muokata"
            Title="Valitse kohde"
          />
        </div>
      </Container>
    </>
  );
};

export default DefaultRates;
